<template>
	<div id="content" v-if="show">
		<section class="slider" style="position:relative;">
			<div class="item" :style="'background-image:url('+baseUrl + welcome.banner_image+'); width: 100%; height: 90vh; background-position: center center; background-size: cover; z-index: 0;'">
				<div class="overlay" style="background-color:rgba(0,0,0,0)"></div>
				<div class="container">
					<div class="format-standard">
						<div class="slide-text-bg1">
							<h1>{{welcome.welcome_title}}</h1>
							<p>{{welcome.welcome_content}}</p>
						</div>
						<div class="slide-btn-area-sm">
							<router-link class="slide-btn-sm" to="/about_us">{{ lang == 1 ? '了解更多' : 'Learn more'}}</router-link>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- Section Title -->
		<section class="service-section" v-if="content[1].category.status == 1">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<div class="section-header">
							<h1 class="widget-title">{{content[1].category.title}}</h1>
							<div class="widget-separator"><span></span></div>
							<p class="wow fadeInDown">{{content[1].category.desc_text}}</p>
						</div>
					</div>
				</div>
				<!-- /Section Title -->
				<div class="row" id="service_content_section">
					<div class="col-md-4 col-sm-6 col-xs-12" v-for="item in content[1].list">
						<div class="post text-center wow flipInX" data-wow-delay=".5s">
							<figure class="post-thumbnail" style="display: flex;justify-content: center;">
								<img style="width: 78px; height: 68px;" :src="baseUrl + item.cover_image" />
							</figure>
							<a href="javascript:;">
								<div class="entry-header">
									<h4 class="entry-title">{{item.title}}</h4>
								</div>
							</a>
							<div class="entry-content" v-html="escape2Html(item.content)">
							</div>
						</div>
					</div>
				</div>
				<!-- /.row -->
				<div class="row"></div>
			</div>
		</section>

		<div class="clearfix"></div>
		<section class="testimonial-section" style="background-image:url(/static/image/国家基因库.png); background-repeat: no-repeat; background-position: top left;" v-if="content[2].category.status == 1">
			<div class="overlay" style="background-color:rgba(0,0,0,0.6)">
				<div class="container">
					<!-- Section Title -->
					<div class="row">
						<div class="col-md-12">
							<div class="section-header">
								<h1 class="white wow fadeInUp" data-wow-delay="0ms" data-wow-duration="500ms">{{content[3].category.title}}</h1>
								<div class="widget-separator"><span></span></div>
								<p class="white wow fadeInDown">{{content[3].category.desc_text}} </p>
							</div>
						</div>
					</div>
					<!-- /Section Title -->
					<!-- Testimonial -->
					<div class="row">
						<div class="item">
							<div class="media testmonial-area">
								<div class="author-box">
									<img :src="baseUrl + content[3].list[0].cover_image" class="img-circle" alt="img">
								</div>
								<div class="media-body">
									<div class="description-box">
										<div class="author-description">
											<p>{{content[3].list[0].content}}</p>
										</div>
									</div>
									<h4>{{content[3].list[0].title}}</h4>
								</div>

							</div>
						</div>
					</div>
					<!-- /Testimonial -->

				</div>
			</div>
		</section>
		<!-- /Testimonial Section -->

		<!-- Portfolio Section -->
		<section class="home-news" id="blog2" v-if="content[5].category.status == 1">
			<div class="container">
				<!-- Section Title -->
				<div class="row">
					<div class="col-md-12">
						<div class="section-header">
							<h1 class="widget-title wow fadeInUp" data-wow-duration="500ms" data-wow-delay="0ms">
								{{content[5].category.title}}
							</h1>
							<div class="widget-separator"><span></span></div>
							<p class="wow fadeInDown">{{content[5].category.desc_text}}</p>
						</div>
					</div>
				</div>
				<!-- /Section Title -->
				<div class="row">
					<div class="col-md-4 col-sm-6 col-xs-12" v-for="(item,index) in content[5].list">
						<article class="post wow fadeInDown" data-wow-delay="0.4s" style="height: 446px;overflow: hidden;">
							<div class="entry-meta">
								<span class="entry-date">
									<a href="javascript:;"><time datetime="">{{item.date}}</time></a>
								</span>
							</div>
							<header class="entry-header">
								<h4 class="entry-title"><router-link :to="{name:'article',params: { id: item.article_id }}" style="display: block;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item.title}}</router-link></h4>
								<div class="entry-meta">
									<span class="author">{{lang == 1 ? '作者' : 'Author'}} <a rel="tag" href="javascript:;">{{item.author_name}}</a></span>
									<span class="cat-links">{{lang == 1 ? '在' : 'in'}}<a href="javascript:;" rel="category tag">{{item.category}}</a></span>
								</div>
							</header>
							<div class="entry-content">
								<figure class="wp-block-image size-large is-resized">
									<img loading="lazy" :src="baseUrl + item.cover_image" alt="" class="wp-image-83" style="width: 328px; height: 174px;" width="590" height="312" />
									<figcaption class="text-content" v-html="item.content" style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;"></figcaption>
								</figure>
							</div>
						</article>
					</div>
				</div>
			</div>
		</section>
		<!-- /Portfolio Section -->

		<!-- Portfolio Section -->
		<section class="home-news" id="blog3" v-if="content[6].category.status == 1">
			<div class="container">
				<!-- Section Title -->
				<div class="row">
					<div class="col-md-12">
						<div class="section-header">
							<h1 class="widget-title wow fadeInUp" data-wow-duration="500ms" data-wow-delay="0ms">
								{{content[6].category.title}}
							</h1>
							<div class="widget-separator"><span></span></div>
							<p class="wow fadeInDown">{{content[6].category.desc_text}}</p>
						</div>
					</div>
				</div>
				<!-- /Section Title -->
				<div class="row">
					<div class="col-md-4 col-sm-6 col-xs-12" v-for="(item,index) in content[6].list">
						<article class="post wow fadeInDown" data-wow-delay="0.4s" style="height: 446px;overflow: hidden;">
							<div class="entry-meta">
								<span class="entry-date">
									<a href="javascript:;"><time datetime="">{{item.date}}</time></a>
								</span>
							</div>
							<header class="entry-header">
								<h4 class="entry-title"><router-link :to="{name:'comm_article',params: { id: item.article_id }}" style="display: block;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item.title}}</router-link></h4>
								<div class="entry-meta">
									<span class="author">{{lang == 1 ? '作者' : 'Author'}} <a rel="tag" href="javascript:;">{{item.author_name}}</a></span>
									<span class="cat-links">{{lang == 1 ? '在' : 'in'}}<a href="javascript:;" rel="category tag">{{item.category}}</a></span>
								</div>
							</header>
							<div class="entry-content">
								<figure class="wp-block-image size-large is-resized">
									<img loading="lazy" :src="baseUrl + item.cover_image" alt="" class="wp-image-83" style="width: 328px; height: 174px;" width="590" height="312" />
									<figcaption class="text-content" v-html="item.content" style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;"></figcaption>
								</figure>
							</div>
						</article>
					</div>
				</div>
			</div>
		</section>
		<!-- /Portfolio Section -->

		<div class="clearfix"></div>
		<!-- Latest News section -->
		<section class="home-news" id="blog" v-if="content[4].category.status == 1">
			<div class="container">
				<!-- Section Title -->
				<div class="row">
					<div class="col-md-12">
						<div class="section-header">
							<h1 class="widget-title wow fadeInUp" data-wow-duration="500ms" data-wow-delay="0ms">
								{{content[4].category.title}}
							</h1>
							<div class="widget-separator"><span></span></div>
							<p class="wow fadeInDown">{{content[4].category.desc_text}}</p>
						</div>
					</div>
				</div>
				<!-- /Section Title -->
				<div class="row">
					<div class="col-md-4 col-sm-6 col-xs-12" v-for="(item,index) in content[4].list">
						<article class="post wow fadeInDown" data-wow-delay="0.4s" style="height: 446px;overflow: hidden;">
							<div class="entry-meta">
								<span class="entry-date">
									<a href="javascript:;"><time datetime="">{{item.date}}</time></a>
								</span>
							</div>
							<header class="entry-header">
								<h4 class="entry-title"><router-link :to="{name:'article',params: { id: item.article_id }}" style="display: block;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item.title}}</router-link></h4>
								<div class="entry-meta">
									<span class="author">{{lang == 1 ? '作者' : 'Author'}} <a rel="tag" href="javascript:;">{{item.author_name}}</a></span>
									<span class="cat-links">{{lang == 1 ? '在' : 'in'}}<a href="javascript:;" rel="category tag">{{item.category}}</a></span>
								</div>
							</header>
							<div class="entry-content">
								<figure class="wp-block-image size-large is-resized">
									<img loading="lazy" :src="baseUrl + item.cover_image" alt="" class="wp-image-83" style="width: 328px; height: 174px;" width="590" height="312" />
									<figcaption class="text-content" v-html="item.content" style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;"></figcaption>
								</figure>
							</div>
						</article>
					</div>
				</div>
			</div>
		</section>
		<!-- /Latest News Section -->
		<div class="clearfix"></div>
	</div>
</template>

<script>
	import { getSiteConfig, getIndex, getArticle } from '../api/api';
	import { WOW } from 'wowjs';
	export default {
		data() {
			return {
				show: false,
				baseUrl: 'http://admin.brlsea.org',
				welcome: '',
				content: '',
				article: []
			};
		},
		props: ['lang'],
		methods: {
			onGetValue() {
				let that = this;
				getSiteConfig({ //banner
					lang: this.lang
				}).then(res => {
					if(res.code == 1) {
						that.welcome = res.data;
					}
				});
				getArticle({ //文章列表
					lang: this.lang,
					page: 1,
					size: 3
				}).then(res => {
					if(res.code == 1) {
						that.article = res.data;
					}
				});
				getIndex({ //首页数据
					lang: this.lang
				}).then(res => {
					if(res.code == 1) {
						that.content = res.data;
						that.show = true;
						setTimeout(() => {
							new WOW().init();
						}, 100)
					}
				});
			},
			escape2Html(str) {
				var arrEntities = {
					'lt': '<',
					'gt': '>',
					'nbsp': '',
					'amp': '&',
					'quot': '"'
				};
				return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function(all, t) {
					return arrEntities[t];
				});
			}
		},
		created() {
			this.onGetValue()
		},
		mounted() {

		}
	};
</script>

<style scoped="scoped">
	@media only screen and (min-width: 960px) and (max-width: 1200px) {
		.slide-text-bg1 {
			padding: 10px 15px 13px;
			width: 100%;
		}
		/*About*/
		.about-img-area {
			margin: 0 0 25px;
			padding: 0px;
			position: relative;
		}
	}
	
	@media only screen and (min-width: 768px) and (max-width: 959px) {
		.slide-text-bg1 {
			width: 100%;
		}
		/*Callout*/
		.sm-callout-btn {
			float: left;
			margin-top: 15px;
		}
		/*About*/
		.about-img-area {
			margin: 0 0 25px;
			padding: 0px;
			position: relative;
		}
	}
	
	@media only screen and (min-width: 200px) and (max-width: 767px) {
		/*Header Contact Info*/
		.header-contact-info {
			float: none;
			text-align: center !important;
		}
		.header-sidebar .col-md-6:nth-child(2) ul.header-contact-info {
			padding-top: 0px;
		}
		.header-contact-info li {
			padding: 0;
		}
		.slide-text-bg1 {
			width: 100%;
		}
		/*Testimonial*/
		.testmonial-area {
			padding: 0;
		}
		.testmonial-area h4 {
			text-align: center;
		}
		.author-box {
			float: none;
			margin: 0 auto 20px;
		}
		.description-box {
			padding: 15px;
		}
		.description-box:before {
			right: 0;
			left: 0;
			margin: 0 auto;
		}
		.author-description p {
			text-align: center;
		}
		/*Callout*/
		.sm-callout-btn {
			float: left;
			margin-top: 15px;
		}
		/*About*/
		.about-img-area {
			margin: 0 0 25px;
			padding: 0px;
			position: relative;
		}
		/*Top Book Button*/
		.sm-top-btn {
			float: left;
			padding: 25px 20px 25px 0;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/index.vue